import { PipeTransform } from '@angular/core';
var FirstLetters = /** @class */ (function () {
    function FirstLetters() {
    }
    FirstLetters.prototype.transform = function (value) {
        if (value && value.length) {
            var wordsArray = value.split(' ');
            var lowerWordsArray = wordsArray.map(function (el, index) { return index === 0 ? el : el.toLowerCase(); });
            return lowerWordsArray.join(' ');
        }
        else {
            return value;
        }
    };
    return FirstLetters;
}());
export { FirstLetters };
